import React, { useEffect, useState } from "react";
import Header from "../sharedComponents/header";
import AskSection from "../home/askSection";
import FooterUser from "../sharedComponents/footer";
import AddComment from "./AddComment";
import TestimonialCard from "./TestimonialCard";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllComments } from "../../redux/reducer/commentReducer";
import LoadingSpinner from "../animation/LoadingSpinner";
import { getAddressesByUserId } from "../../redux/reducer/userAddressReducer";

export const Testimonials = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const limit = 5;
  const [commentsAll, setCommentsAll] = useState([]);
  const [hasMorePagesLocal, setHasMorePagesLocal] = useState(false);
  const { loading } = useSelector((state) => state.comments);
  const { addresses } = useSelector((state) => state.userAddress);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const resultAction = await dispatch(
          fetchAllComments({ page, limit })
        ).unwrap();
        dispatch(getAddressesByUserId()).unwrap();
        setCommentsAll((prev) => {
          const ids = new Set(prev.map((item) => item._id));
          const filtered = resultAction.data.filter(
            (item) => !ids.has(item._id)
          );
          return [...prev, ...filtered];
        });
        setHasMorePagesLocal(resultAction.pagination.hasMorePages);
      } catch (err) {
        console.error(err);
      }
    };
    fetchPage();
  }, [dispatch, page]);

  const handleSeeMore = () => {
    setPage((prev) => prev + 1);
  };
  // console.log(addresses.user.isPaid);
  return (
    <div>
      <Header />
      {addresses?.user?.isPaid && <AddComment />}
      {/* <AddComment /> */}
      {loading && page === 1 ? (
        <div className="flex justify-center py-8">
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <TestimonialCard
            testimonials={commentsAll}
            isPaid={addresses?.user?.isPaid}
          />

          {/* See More */}
          {hasMorePagesLocal && (
            <div className="relative flex justify-center pb-10 max-container">
              <button
                onClick={handleSeeMore}
                className="px-6 py-2 mt-4 text-white transition-transform bg-black rounded-md hover:scale-105"
              >
                {t("SeeMore")}
              </button>
            </div>
          )}
        </>
      )}

      <AskSection />
      <FooterUser />
    </div>
  );
};
